import { render, staticRenderFns } from "./UserReviewArea.vue?vue&type=template&id=60eed392&"
import script from "./UserReviewArea.vue?vue&type=script&lang=ts&"
export * from "./UserReviewArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports